<template>
<Header />
<Main heading="Our Work">
  <main-view :categories="categories">
      <div class="content">
        <testing v-if="section=='product_testing'"/>
        <survey-services v-else-if="section=='survey_and_services'"/>
        <research-projects v-else-if="section=='research_projects'"/>
        <what-we-do v-else/>
      </div>
  </main-view>
</Main>
<Footer />
</template>

<script>
import { useGtag } from "vue-gtag-next";
import Header from "../../components/Header/_Header.vue";
import Main from "../../components/Main/_Main.vue";
import MainView from "../../components/MainView/_MainView.vue";
import WhatWeDo from './views/WhatWeDo/_WhatWeDo.vue';
import Testing from './views/Testing/_Testing.vue';
import SurveyServices from './views/SurveyServices/_SurveyServices.vue';
import ResearchProjects from './views/ResearchProjects/_ResearchProjects.vue';
import Footer from "../../components/Footer/_Footer";
import workCategories from '../pages.json';

export default {
  name: "Work",
  data() {
    return {
      section: null,
      categories: workCategories.work,
    };
  },  
   setup() {
    const { pageview } = useGtag() 
    const track = () => {
      pageview({ page_path: "https://www.international-testing.org/work.html" });
    };
    return {
      track,
    };
   },
  components: {
    Header,
    Main,
    MainView,
    WhatWeDo,
    Testing,
    SurveyServices,
    ResearchProjects,
    Footer,
  },
    watch: {
     $route(to){
       this.section=to.query.section;
     }
    }
};
</script>

<style  lang="scss">
</style>
